<template>
  <div class="collapse-editor">
    <el-form ref="form" label-width="80px">
      <el-form-item label="上边距">
        <el-slider v-model="currentItem.style.margin_top" style="padding-left:10px;"></el-slider>
      </el-form-item>
      <el-form-item label="左右边距">
        <el-slider v-model="currentItem.style.padding" style="padding-left:10px;"></el-slider>
      </el-form-item>
      <el-form-item label="标题">
        <el-input v-model="currentItem.title" placeholder="请输入"></el-input>
      </el-form-item>
      <el-form-item label="折叠个数">
        <el-input-number v-model="currentItem.style.collapse_number" :min="0"></el-input-number>
        <p style="color:red;font-size:13px;">提示：位于折叠面板下面的模块可折叠个数</p>
      </el-form-item>
      <el-form-item label="是否折叠">
        <el-switch
          v-model="currentItem.style.is_collapse"
          :active-value="1"
          :inactive-value="0"
          @change="switchChange">
        </el-switch>
      </el-form-item>
    </el-form>
  </div>
</template>
<script>
export default {
  name: 'collapseEditor',
  data () {
    return {}
  },
  created () {
    this.switchChange(this.currentItem.style.is_collapse)
  },
  computed: {
    currentItem () {
      return this.$store.state.page.currentItem
    }
  },
  watch: {
    currentItem: {
      handler (oldValue, newValue) {
        if (oldValue.style.is_collapse === newValue.style.is_collapse) {
          return
        }
        this.switchChange(this.currentItem.style.is_collapse)
      },
      deep: true
    }
  },
  methods: {
    switchChange (e) {
      let data = this.$store.state.page.data
      let number = this.currentItem.style.collapse_number
      let start = false
      data.forEach(item => {
        if (start && number > 0) {
          item.style.display = e === 0 ? 'block' : 'none'
          number--
        }
        if (item === this.currentItem) {
          start = true
        }
      })
      // this.$store.commit('COLLAPSE_CHANGE')
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/PageEditor/editors/collapseEditor.vue